module.exports = __webpack_public_path__ + "static/media/social.133af411.jpg";